<template>
  <div class="sync-toast" role="status" aria-live="polite">
    <button
      type="button"
      class="pill"
      :class="[toneClass, { 'is-expanded': expanded }]"
      :aria-expanded="expanded ? 'true' : 'false'"
      @click="expanded = !expanded"
    >
      <span class="pill-main">
        <span class="dot" />
        <strong class="title">{{ state.title }}</strong>
      </span>
      <span class="chev" aria-hidden="true">
        <i class="fas" :class="expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
      </span>
    </button>

    <div v-if="expanded" class="panel" :class="toneClass">
      <p class="msg">{{ state.message }}</p>

      <ul class="details">
        <li>
          <span class="k">{{ $t('sync.details.connection') }}:</span>
          <span class="v">{{ onlineText }}</span>
        </li>

        <li>
          <span class="k">{{ $t('sync.details.unsynced_changes') }}:</span>
          <span class="v">{{ dirty ? $t('common.yes') : $t('common.no') }}</span>
        </li>

      </ul>

      <div class="actions" v-if="state.action">
        <button class="sync-action button is-small" @click.stop="state.action.onClick">
          {{ state.action.label }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SyncToast',
  props: {
    state: { type: Object, required: true },
    dirty: { type: Boolean, default: false },
    hasLocalDraft: { type: Boolean, default: false },
    isOnline: { type: Boolean, default: true },
  },
  data: () => ({ expanded: false }),
  computed: {

    toneClass() {
      if (this.storageRelevant) {
        if (this.storage?.level === 'critical') return 'is-danger';
        if (this.storage?.level === 'low') return 'is-warning';
      }

      if (this.state.tone === 'success') return 'is-success';
      if (this.state.tone === 'warning') return 'is-warning';
      if (this.state.tone === 'info') return 'is-info';

      return 'is-light';
    },
    onlineText() {
      return this.isOnline ? this.$t('sync.online') : this.$t('sync.offline');
    }
  }
};
</script>
<style scoped>
.sync-toast {
  top: 2.75rem;
  padding: 10px 0;
  position: sticky;
  z-index: 3;
  width: 100%;
  max-width: 50%;
  box-sizing: border-box;
}

.pill {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 999px;
  border: 0;
  color: inherit;
  font: inherit;
  text-align: left;
  background: transparent;
  cursor: pointer;
  user-select: none;
  box-sizing: border-box;
}

.pill-main {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1 auto;
}

.pill.is-success { background: rgba(72, 199, 142, 1); }
.pill.is-warning { background: rgba(255, 221, 87, 1); }
.pill.is-info    { background: rgba(32, 156, 238, 1); }
.pill.is-light   { background: rgba(245, 245, 245, 1); }

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: currentColor;
  opacity: 0.9;
}

.title {
  min-width: 0;
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.3;
  overflow-wrap: anywhere;
}

.chev {
  flex: 0 0 auto;
  margin-left: 6px;
  opacity: 0.7;
}

.panel {
  margin-top: 8px;
  padding: 12px;
  width: 100%;
  border-radius: 8px;
  background: white;
  border: 1px solid rgba(0,0,0,.08);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
}

.panel.is-warning { border-color: rgba(255,221,87,.6); }
.panel.is-success { border-color: rgba(72,199,116,.5); }
.panel.is-info    { border-color: rgba(32,156,238,.4); }

.msg {
  margin-bottom: 10px;
  overflow-wrap: anywhere;
}

.details {
  margin: 0;
  padding: 0;
  list-style: none;
}

.details li {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 6px;
  margin: 6px 0;
}

.k { opacity: 0.7; margin-right: 6px; }
.actions {
  margin-top: 10px;
  display: flex;
}

.sync-action {
  min-height: 40px;
}

.pill.is-danger { background: rgba(255, 56, 96, 0.38); }
.panel.is-danger { border-color: rgba(255, 56, 96, .5); }

@media (max-width: 768px) {
  .sync-toast {
    max-width: 100%;
    padding: 8px 0 12px;
  }

  .pill {
    align-items: flex-start;
    border-radius: 16px;
  }

  .pill-main {
    align-items: flex-start;
  }

  .panel {
    padding: 14px;
    border-radius: 14px;
  }

  .actions {
    margin-top: 12px;
  }

  .sync-action {
    width: 100%;
    justify-content: center;
  }
}
</style>
